<template>
  <footer>
    <div class="footer_content">
      <h3>联系我们</h3>
      <div class="contact_list">
        <div class="online_customer" onclick="window.open('https://vue.livelyhelp.chat/chatWindow.aspx?siteId=5000757&planId=314&chatGroup=3')">
          <img src="../assets/custom_icon.png" alt="线上客服" />
          <p>线上客服</p>
        </div>
        <ul>
          <li v-for="(item, idx) in items" :key="idx">
            <h6>{{item.type}}</h6>
            <p>{{item.id}}</p>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import { footerObj } from '@/utils/page_setting'

export default {
  name: 'hi-footer',
  computed: {
    items () {
      return footerObj
    }
  }
}
</script>

<style lang="less" scoped>
footer{
  min-height: 250px;
  background: #00077a;
  .footer_content{
    display: flex;
    min-height: inherit;
    width: max-content;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: left;
    margin: 0 auto;
    h3{
      font-size: 1.33em;
      color: #FFF;
      align-self: flex-start;
      margin: 0 0 1.67em;
    }
    .contact_list{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      img{
        width: 60px;
        height: 60px;
      }
      p{
        font-size: 1.11em;
        color: #c3aa5b;
        font-weight: 600;
        margin: 0;
      }
      .online_customer{
        display: inline-block;
        margin: 0 8.3em 0 .8em;
        text-align: center;
        cursor: pointer;
      }
      ul, li{list-style: none;}
      ul{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;
        margin: 0;
        li{
          display: inline-block;
          margin-right: 3.8em;
          &:last-child{margin-right: 0;}
          h6{
            font-size: 0.83em;
            color: #c7c7cc;
            line-height: 1.67;
            margin: 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  footer{
    min-height: 6vh;
    padding: 2.6em 2em 2em;
    .footer_content{
      width: 100%;
      align-items: flex-start;
      h3{
        margin: 0 0 1em;
      }
      .contact_list{
        img{
          width: 4.2em;
          height: 4.2em;
        }
        .online_customer{
          min-width: 5em;
          margin: 0 5em 0 0;
        }
        ul{
          flex-wrap: wrap;
          margin: 1.2em 0 0;
          li{
            margin-bottom: 1em;
            h6{
              line-height: 1.8;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767.9px) {
  footer{
    width: 100%;
    min-height: 5em;
    background: #00077a;
    padding: 1.5em 1em .5em;
    .footer_content{
      width: 100%;
      margin: 0 auto;
      justify-content: flex-start;
      h3{
        font-size: 1.1em;
        color: #FFF;
        align-self: flex-start;
        margin: 0 0 1em;
      }
      .contact_list{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        img{
          width: 4em;
          height: 4em;
        }
        p{
          font-size: .95em;
          color: #c3aa5b;
          font-weight: 600;
          margin: 0;
        }
        .online_customer{
          width: 20vw;
          align-self: baseline;
          display: inline-block;
          margin: 0 1.8em 0 0;
          text-align: center;
        }
        ul, li{list-style: none;}
        ul{
          display: flex;
          width: auto;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          padding: 0;
          margin: 0;
          li{
            min-width: 6em;
            display: inline-block;
            margin-right: 1.5em;
            margin-bottom: 1em;
            &:last-child{margin-right: 0;}
            h6{
              font-size: 0.7em;
              color: #c7c7cc;
              line-height: 1.67;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
